import { apiClient } from '@/shared/api/client'

export interface InvitationPreview {
  organization_name: string | null
  email: string
  inviter_name: string | null
  status: string
  expired: boolean
  project_name?: string | null
}

export async function getInvitationByToken(token: string): Promise<InvitationPreview> {
  const response = await apiClient.get<{ data: InvitationPreview }>(`/invitations/${token}`)
  return response.data.data
}

export async function acceptInvitation(token: string): Promise<void> {
  await apiClient.post(`/organization/invitations/${token}/accept`)
}
